import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const FileDropOverlay = ({ sx }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'primary.main',
        borderRadius: 1,
        zIndex: 10,
        color: 'white',
        pointerEvents: 'none',
        transition: 'opacity 0.3s ease-in-out',
        opacity: .85,
        ...sx,
      }}
    >
      <CloudUploadIcon sx={{ fontSize: 60, mb: 1 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        Drop your file here!
      </Typography>
      <Typography variant="body2">
        (.txt, .log, .json, whatever)
      </Typography>
    </Box>
  );
};

export default FileDropOverlay;